import React from "react";
import './componentTool.css'
import './QuestionSelect.css'


const QuestionSelect = ({title, showStats, multStatus, onClick}) => {
    const selectImg = require("../assets/tool/selected.png")
    const unselectImg = require("../assets/tool/unselect.png")

    const selectMultImg = require("../assets/tool/multSelected.png")
    const unselectMultImg = require("../assets/tool/multUnselect.png")

    return(
        <div className={`questionCV ${showStats ? 'selected' : ''} ${multStatus ? 'multiselect' : ''}`} onClick={onClick}>
            {!multStatus && <img src={showStats ?selectImg : unselectImg} className="selectImgV"></img> }
            {multStatus && <img src={showStats ?selectMultImg : unselectMultImg} className="selectImgV"></img> }
            <p className="questionCL">{title}</p>
        </div>
    )
}

export default QuestionSelect